import { IDecreesBarState } from './DecreesBar-types';

const decreesBarState: IDecreesBarState = {
    state: {
        showDecreesModal: false,
    },
    mutations: {
        setShowDecreesModal(state, value: boolean) {
            state.showDecreesModal = value;
        },
    },
    actions: {
        async setShowDecreesModal({ commit }, value: boolean) {
            commit('setShowDecreesModal', value);
        },
    },
};

export default decreesBarState;
